// extracted by mini-css-extract-plugin
export var formContainer = "_io-0";
export var message = "_io-1";